import { Star } from "lucide-react";
import { useState } from "react";

export function StarRating({ value = 0, onChange, size = 18, readOnly = false, testIdPrefix = "star" }) {
  const [hover, setHover] = useState(0);
  const display = hover || value;

  return (
    <div className="flex items-center gap-0.5" data-testid={`${testIdPrefix}-rating`}>
      {[1, 2, 3, 4, 5].map((n) => {
        const active = n <= display;
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            onMouseEnter={() => !readOnly && setHover(n)}
            onMouseLeave={() => !readOnly && setHover(0)}
            onClick={() => !readOnly && onChange?.(n)}
            className={`p-0.5 ${readOnly ? "cursor-default" : "cursor-pointer hover:scale-110"} transition-transform duration-150`}
            data-testid={`${testIdPrefix}-${n}`}
            aria-label={`${n} stars`}
          >
            <Star
              size={size}
              strokeWidth={1.5}
              className={active ? "fill-[#0A0A0A] text-[#0A0A0A]" : "text-[#A3A3A3]"}
            />
          </button>
        );
      })}
    </div>
  );
}

export function StarDisplay({ value = 0, size = 14 }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1,2,3,4,5].map((n) => (
        <Star key={n} size={size} strokeWidth={1.5}
              className={n <= Math.round(value) ? "fill-[#0A0A0A] text-[#0A0A0A]" : "text-[#D1D5DB]"} />
      ))}
    </div>
  );
}
